//
// Module for the Retirement Setup wizard's DROP Exit Taxability step
//
rs.module("participant/benefit/setup/retirement/wizard/dropexittaxabilitystep",

    ["controls/components/event-banner"],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, variables) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var disbursementTypeSelect = stepContainer.js(jsSelectors.disbursementTypeSelect);
            var disbursementAmountInput = stepContainer.js(jsSelectors.disbursementAmountInput);
            var disbursementAmountHidden = stepContainer.js(jsSelectors.disbursementAmountHidden);

            // Hookup disbursementTypeSelect change event
            disbursementTypeSelect.change(disbursementTypeChange);

            // Disbursement Type change event
            function disbursementTypeChange() {

                // Get selected Disbursement Type
                var selectedDisbursementType = disbursementTypeSelect.val();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                if (selectedDisbursementType == codeValues.totalDropDisbursement) {
                    disbursementAmountInput.prop("disabled", true).val(variables.currentBalance);
                    disbursementAmountHidden.val(variables.currentBalance);
                }
                else {
                    disbursementAmountInput.prop("disabled", false).val("");
                    disbursementAmountHidden.val("");
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);